import { LoyaltyEarnedMeasureOption } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { LoyaltyEarnedState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/loyalty-earned";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import {
  RadioGroupOption,
  RedoRadioGroup,
} from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { memo } from "react";

const MEASURE_OPTIONS: RadioGroupOption<LoyaltyEarnedMeasureOption>[] = [
  { id: LoyaltyEarnedMeasureOption.PERCENT, label: "%" },
  { id: LoyaltyEarnedMeasureOption.AMOUNT, label: "Raw amount" },
];

export const LoyaltyEarnedDetails = memo(function LoyaltyEarnedDetails({
  state,
  setState,
}: ConditionTypeDetailsProps<LoyaltyEarnedState>) {
  return (
    <>
      <RedoRadioGroup
        options={MEASURE_OPTIONS}
        setValue={(measureOption) => setState({ ...state, measureOption })}
        size="xs"
        value={state.measureOption}
      />
      <RedoTextInput
        inputTypeHint="number"
        label="Value"
        max={
          state.measureOption === LoyaltyEarnedMeasureOption.PERCENT
            ? 100
            : undefined
        }
        min={0}
        setValue={(e) => {
          setState({ ...state, value: +e });
        }}
        size="sm"
        value={state.value.toString()}
      />
    </>
  );
});
